/**
 * @larroude/cross-sell — comportamento do cross-sell-card (STP-6165, épico STP-6058)
 *
 * Estados do botão (CA-07): Adicionar → Escolher tamanho → Adicionado ✓ (1,6 s).
 * Modalidade sempre visível antes da adição (RF-GER-01); "Seu tamanho" destacado
 * a partir do calçado já presente na sacola (RF-GER-03); tamanho não comprável é
 * inerte (CA-03). Adição via /cart/add.js; o refresh do drawer e do contador do
 * header é do bundle vendor, acionado pelo evento DOM "apps:product-added-to-cart".
 *
 * Listeners delegados em document: sobrevivem à re-renderização das sections
 * pela Section Rendering API (drawer e cart page trocam o DOM inteiro).
 */
(function () {
  'use strict';

  if (window.__larCrossSellInit) return;
  window.__larCrossSellInit = true;

  var ADDED_MS = 1600;
  var SIZE_OPTION_NAMES = ['size', 'tamanho', 'tamanhos'];

  var cartRoutes = (window.theme && window.theme.routes && window.theme.routes.cart) || {};
  var ADD_URL = (cartRoutes.add || '/cart/add') + '.js';
  var CART_URL = (cartRoutes.base || '/cart') + '.js';

  // Cache da sacola só para a sugestão de tamanho; invalidado a cada adição.
  var cartSizePromise = null;

  function getCard(el) {
    return el.closest('[data-cross-sell-card]');
  }

  function setStatus(card, text) {
    var status = card.querySelector('[data-xs-status]');
    if (status) status.textContent = text;
  }

  function modalityText(card, chipOrBtn) {
    var fulfillment = chipOrBtn.getAttribute('data-fulfillment');
    var promise = chipOrBtn.getAttribute('data-promise') || '';
    var label = fulfillment === 'preorder' ? card.dataset.strPreorder : card.dataset.strReady;
    if (fulfillment === 'preorder' && promise) return label + ' · ' + promise;
    return label;
  }

  // RF-GER-03: tamanho de calçado já na sacola. Retorna Promise<string|null>.
  function getCartSize() {
    if (!cartSizePromise) {
      cartSizePromise = fetch(CART_URL, { credentials: 'include' })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var size = null;
          (cart.items || []).forEach(function (item) {
            if (size) return;
            (item.options_with_values || []).forEach(function (opt) {
              if (size) return;
              var name = (opt.name || '').toLowerCase();
              if (SIZE_OPTION_NAMES.indexOf(name) !== -1 && opt.value) {
                size = String(opt.value);
              }
            });
          });
          return size;
        })
        .catch(function () { return null; });
    }
    return cartSizePromise;
  }

  // Normaliza um rótulo de tamanho para comparação entre produtos: o catálogo
  // BR mistura formatos ("33 (US 5.0)" vs "33 (US 5)"), então a chave é a
  // numeração BR — o primeiro número do rótulo. (Achado no E2E da loja teste.)
  function normalizeSize(value) {
    var match = String(value).match(/\d+(?:[.,]\d+)?/);
    return match ? String(parseFloat(match[0].replace(',', '.'))) : String(value).trim().toLowerCase();
  }

  function highlightSuggestedSize(card) {
    getCartSize().then(function (size) {
      if (!size) return;
      var sizeKey = normalizeSize(size);
      var chips = card.querySelectorAll('[data-xs-chip]');
      chips.forEach(function (chip) {
        // Nunca sugerir tamanho esgotado nem um tamanho diferente do da sacola.
        if (chip.getAttribute('aria-disabled') === 'true') return;
        if (normalizeSize(chip.getAttribute('data-label')) !== sizeKey) return;
        chip.classList.add('cross-sell-card__chip--suggested');
        chip.setAttribute('data-suggested', 'true');
        var tag = chip.querySelector('[data-xs-suggestion]');
        if (tag) tag.hidden = false;
      });
    });
  }

  function pushAnalytics(card, trigger) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_to_cart',
      source: card.dataset.source || 'cross_sell',
      fulfillment: trigger.getAttribute('data-fulfillment') === 'preorder' ? 'pre_venda' : 'pronta_entrega',
      size_suggested: trigger.getAttribute('data-suggested') === 'true',
      currency: card.dataset.currency,
      item_id: trigger.getAttribute('data-sku') || trigger.getAttribute('data-variant-id'),
      item_name: card.dataset.productTitle,
      variant_id: trigger.getAttribute('data-variant-id'),
      quantity: 1
    });
  }

  function showAdded(card, label) {
    var original = card.dataset.strAdd;
    label.textContent = card.dataset.strAdded;
    window.setTimeout(function () {
      // O card pode ter saído do DOM (drawer re-renderizado) — guard barato.
      if (label.isConnected) label.textContent = original;
      var chips = card.querySelector('[data-xs-chips]');
      if (chips && chips.isConnected) chips.hidden = true;
    }, ADDED_MS);
  }

  function addToCart(card, trigger, labelEl) {
    var variantId = parseInt(trigger.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    // RF-GER-01: modalidade visível no momento da adição, e mantida na confirmação.
    setStatus(card, modalityText(card, trigger));
    card.classList.add('cross-sell-card--busy');

    fetch(ADD_URL, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
      .then(function (result) {
        card.classList.remove('cross-sell-card--busy');
        if (!result.ok || result.json.status === 422) {
          setStatus(card, result.json.description || card.dataset.strError);
          return;
        }

        cartSizePromise = null;
        pushAnalytics(card, trigger);
        showAdded(card, labelEl);

        // Bundle vendor: re-renderiza a quick-cart e o contador do header.
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
        // Gancho para as superfícies (ex.: página da sacola re-renderiza a própria section).
        document.dispatchEvent(new CustomEvent('cross-sell:added', {
          detail: {
            variantId: variantId,
            productId: card.dataset.productId,
            source: card.dataset.source
          }
        }));

        if (card.dataset.openDrawer === 'true') {
          var cartIcon = document.querySelector('[data-js-cart-icon]');
          if (cartIcon) cartIcon.click();
        }
      })
      .catch(function () {
        card.classList.remove('cross-sell-card--busy');
        setStatus(card, card.dataset.strError);
      });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-xs-toggle]');
    if (toggle) {
      var card = getCard(toggle);
      var chips = card.querySelector('[data-xs-chips]');
      var label = toggle.querySelector('[data-xs-toggle-label]');
      if (!chips) return;
      var willOpen = chips.hidden;
      chips.hidden = !willOpen;
      if (willOpen) {
        label.textContent = card.dataset.strChoose;
        highlightSuggestedSize(card);
      } else {
        // Novo toque fecha e volta ao estado inicial (RF-DRW-03).
        label.textContent = card.dataset.strAdd;
        setStatus(card, '');
      }
      return;
    }

    var chip = event.target.closest('[data-xs-chip]');
    if (chip) {
      var chipCard = getCard(chip);
      if (chip.getAttribute('aria-disabled') === 'true') {
        setStatus(chipCard, chipCard.dataset.strUnavailable);
        return;
      }
      var toggleLabel = chipCard.querySelector('[data-xs-toggle-label]');
      addToCart(chipCard, chip, toggleLabel);
      return;
    }

    var direct = event.target.closest('[data-xs-add]');
    if (direct) {
      var directCard = getCard(direct);
      var directLabel = direct.querySelector('[data-xs-add-label]');
      addToCart(directCard, direct, directLabel);
    }
  });

  // RF-GER-01: a modalidade acompanha o tamanho focado (teclado) e o hover (mouse).
  function previewModality(event) {
    var chip = event.target.closest && event.target.closest('[data-xs-chip]');
    if (!chip) return;
    var card = getCard(chip);
    if (chip.getAttribute('aria-disabled') === 'true') {
      setStatus(card, card.dataset.strUnavailable);
      return;
    }
    setStatus(card, modalityText(card, chip));
  }
  document.addEventListener('focusin', previewModality);
  document.addEventListener('mouseover', previewModality);

  // ------------------------------------------------------------------
  // Superfícies (STP-6168/6169)
  // ------------------------------------------------------------------

  // STP-6168/RNF-01: as raias da PLP moram em <template> e só entram no DOM
  // quando o wrapper se aproxima do viewport — imagens não disputam o LCP.
  function stampRailTemplates(host) {
    var templates = host.querySelectorAll('template[data-xs-rail]');
    templates.forEach(function (tpl) {
      tpl.replaceWith(tpl.content.cloneNode(true));
    });
  }

  // STP-6169: bucket A/B próprio (sem app de terceiros) — 50/50 por navegador,
  // persistido em localStorage e exposto no dataLayer para o GA4 segmentar.
  // Sem localStorage (Safari privado etc.) o bucket é por pageview, ainda 50/50.
  var abBucket = null;
  function getAbBucket() {
    if (abBucket) return abBucket;
    var stored = null;
    try { stored = window.localStorage.getItem('lar_xs_ab'); } catch (err) { /* noop */ }
    if (stored !== 'a' && stored !== 'b') {
      stored = Math.random() < 0.5 ? 'a' : 'b';
      try { window.localStorage.setItem('lar_xs_ab', stored); } catch (err) { /* noop */ }
    }
    abBucket = stored;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'xs_ab_bucket', xs_ab_bucket: abBucket });
    return abBucket;
  }

  // WeakSet em vez de atributo no DOM: um re-render que clona o host (morph do
  // theme editor/hot-reload, Section Rendering API) copiaria o atributo mas não
  // o observer — o elemento novo ficaria "marcado" e nunca estamparia.
  var boundLazyHosts = new WeakSet();

  function initSurfaces() {
    var lazyHosts = document.querySelectorAll('[data-xs-lazy]');
    lazyHosts.forEach(function (host) {
      if (boundLazyHosts.has(host)) return;
      boundLazyHosts.add(host);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            io.disconnect();
            stampRailTemplates(entry.target);
          });
        }, { rootMargin: '600px 0px' });
        io.observe(host);
      } else {
        stampRailTemplates(host);
      }
    });

    // Módulos sob teste A/B nascem hidden no Liquid; só o bucket "a" os vê.
    var abEls = document.querySelectorAll('[data-xs-ab]');
    if (abEls.length && getAbBucket() === 'a') {
      abEls.forEach(function (el) { el.hidden = false; });
    }
  }

  // STP-6169/RF-CRT: adição via cross-sell na página da sacola re-renderiza a
  // section. Espelha exatamente o refreshCart() do bundle vendor (que só roda
  // nos eventos internos dele): troca o innerHTML de [js-cart-items] e o
  // outerHTML do wrapper de subtotal — os listeners do vendor são delegados no
  // container da section, então sobrevivem ao swap.
  document.addEventListener('cross-sell:added', function () {
    var cartSection = document.querySelector('[data-section-type="cart"]');
    if (!cartSection) return;
    var sectionId = cartSection.getAttribute('data-section-id');
    var base = (cartRoutes.base || '/cart');
    fetch(base + '?section_id=' + sectionId, { credentials: 'include' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var sourceDom = new DOMParser().parseFromString(html, 'text/html');
        var sourceItems = sourceDom.querySelector('[js-cart-items]');
        var targetItems = cartSection.querySelector('[js-cart-items]');
        var sourceSubtotal = sourceDom.querySelector('[js-cart-footer-subtotal-wrapper]');
        var targetSubtotal = cartSection.querySelector('[js-cart-footer-subtotal-wrapper]');
        if (sourceItems && targetItems) targetItems.innerHTML = sourceItems.innerHTML;
        if (sourceSubtotal && targetSubtotal) targetSubtotal.outerHTML = sourceSubtotal.outerHTML;
        initSurfaces();
      })
      .catch(function () { /* mantém o DOM atual; o drawer já refletiu a adição */ });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSurfaces);
  } else {
    initSurfaces();
  }
})();
